var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5Holidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1747 12.6481H25.6456V9.58986C25.6456 5.3695 22.2204 1.94427 18 1.94427C13.7797 1.94427 10.3544 5.3695 10.3544 9.58986V12.6481H8.82533C7.1433 12.6481 5.76709 14.0243 5.76709 15.7063V30.9975C5.76709 32.6795 7.1433 34.0557 8.82533 34.0557H27.1747C28.8568 34.0557 30.233 32.6795 30.233 30.9975V15.7063C30.233 14.0243 28.8568 12.6481 27.1747 12.6481ZM13.4127 9.59046C13.4127 6.97567 15.5382 4.85019 18.1529 4.85019C20.7677 4.85019 22.8932 6.97567 22.8932 9.59046V12.6487H13.4127V9.59046ZM8.82536 30.9975H27.1748V15.7063H8.82536V30.9975Z",
    fill: "#5E5F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.529 23.7073C20.4431 23.1786 21.0581 22.1902 21.0581 21.0582C21.0581 19.3692 19.6889 18 17.9999 18C16.3109 18 14.9417 19.3692 14.9417 21.0582C14.9417 22.1902 15.5567 23.1785 16.4708 23.7073V27.9393H19.529V23.7073Z",
    fill: "#5E5F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5Holidays);
export default __webpack_public_path__ + "static/media/Icon 5 Holidays.80170aafd787f34b8dc6b40c5fdfeb14.svg";
export { ForwardRef as ReactComponent };